import React from 'react';

import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { formatDateSlashWithTime } from '~/services/TimeService';

import RelatedListCard from '../RelatedListCard';
import { RELATED_PREVIEW_LIMIT, accountPath } from '../accountRelatedModel';
import { useAccountOfferId } from '../useAccountOfferId';

import { useAccountNotesAttachments } from './useAccountNotesAttachments';

interface Props {
  accountId: string;
}

export default function AccountNotesAttachmentsCard({ accountId }: Props) {
  const offerId = useAccountOfferId();
  const { error, isLoading, notesAttachments } = useAccountNotesAttachments(accountId);

  return (
    <RelatedListCard
      count={notesAttachments.length}
      error={error}
      icon={<InsertDriveFileIcon color="action" />}
      isLoading={isLoading}
      isSampleData
      title="Notes & Attachments"
      viewAllTo={accountPath(accountId, offerId, '/notes-attachments')}
    >
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: 200 }}>Title</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Last Modified</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notesAttachments.slice(0, RELATED_PREVIEW_LIMIT).map((item) => (
              <TableRow key={item.id} hover>
                <TableCell>{item.title}</TableCell>
                <TableCell>{item.type}</TableCell>
                <TableCell>{formatDateSlashWithTime(item.lastModifiedDate)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </RelatedListCard>
  );
}
